<flx-modal
  [dismissible]="true"
  [contentClass]="'flex flex-col h-[calc(100%-80px)]'"
  (dismiss)="hideModal.emit()"
  class="flx-ds large h-full w-full"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    Runtime Exception
  </div>
  <div class="flx-modal-body">
    @if (context()) {
      <flx-exception-details-content
        [processException]="context()?.processException"
        [applicationDetails]="context()?.applicationDetails"
        [loading]="context()?.loading"
        class="h-full"
      ></flx-exception-details-content>
    }
  </div>
</flx-modal>
